"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseHtmlTags = void 0;
const react_1 = require("react");
const parseHtmlTags = (tags) => Object.entries(tags).map(([key, { type, props, content }]) => (0, react_1.createElement)(type, {
    key,
    ...props,
    // eslint-disable-next-line zillow/@typescript-eslint/naming-convention
    ...(content ? { dangerouslySetInnerHTML: { __html: content } } : {}),
}));
exports.parseHtmlTags = parseHtmlTags;
